var app = angular.module("leonardo");

var ReportsDynamicFormList = function ($scope, $rootScope, $controller, $filter, FilterService, ReportService,AuthService,
                                       ReportFilterService, AttachmentService,AuthDataService) {

  $controller('ReportsBaseController', { $scope: $scope });

  $scope.title = $filter('translate')('Dynamic Form Reports');
  $scope.report_type = ReportService.TYPE_DYNAMIC_FORM;
  $scope.fieldInvalidTypes = ReportFilterService.fieldInvalidTypes;
  $scope.fieldsReport = ReportService.fieldsDynamicFormsReport;
  $scope.initDynamic = false;
  $scope.exp = 1;
  $scope.optionsLanguage = AuthDataService && AuthDataService.authData && AuthDataService.authData.account && AuthDataService.authData.account.languages &&
                            AuthDataService.authData.account.languages.length > 0 ? AuthDataService.authData.account.languages : [];

  $scope.getExtraAttributes = function (report) {
    var html = '';
    if (report.notes) {
      var noteText = (typeof report.notes === 'object' && report.notes !== null && report.notes.content !== undefined) ? report.notes.content : (typeof report.notes === 'object' ? JSON.stringify(report.notes) : report.notes);
      html += '<span class="inline bold">Comment:</span>';
      html += '<span class="italic inline">' + noteText + '</span>';
    }
    if (report.photo) {
      if (angular.isArray(report.photo)) {
        angular.forEach(report.photo, function(photo) {
          html += '<div class="report-photo">';
          var href = photo.link ? photo.link : (photo.document_file ? photo.document_file.signed_view_url : (photo.signed_view_url || photo.file));
          if (!isNull(href)) {
            if (AttachmentService.getClassesAttachment(photo) === 'image') {
              html += '<span><img src="' + href + '" name="' + photo.name + '"/></span>';
            }
            else {
              html += '<span><a href="' + href + '" target="_blank">' + photo.name + '</a></span>';
            }
          }
          if (photo.comment) {
            html += '<span class="inline bold">Photo comment:</span>';
            html += '<span class="italic inline">' + photo.comment + '</span>';
          }
          html += '</div>';
        });
      }
      else {
        html += '<div class="report-photo">';
        var href_link = report.photo.link ? report.photo.link : (report.photo.document_file ? report.photo.document_file.signed_view_url : (report.photo.signed_view_url || report.photo.file));
        if (!isNull(href_link)) {
          if (AttachmentService.getClassesAttachment(report.photo) === 'image') {
            html += '<span><img src="' + href_link + '" name="' + report.photo.name + '"/></span>';
          }
          else {
            html += '<span><a href="' + href_link + '" target="_blank">' + report.photo.name + '</a></span>';
          }
        }
        if (report.photo.comment) {
          html += '<span class="inline bold">Photo comment:</span>';
          html += '<span class="italic inline">' + report.photo.comment + '</span>';
        }
        html += '</div>';
      }
    }
    return html;
  };

  $scope.getLanguageText =function (report) {
    var desiredLanguage = $scope.optionsLanguage && $scope.optionsLanguage.length > 0 && $scope.optionsLanguage.find(function(language) {
      return language.code.toLowerCase() === (report.created_in_language ? report.created_in_language : 'en');
    });
    return desiredLanguage ? desiredLanguage.name : '';
  }

  $scope.getLanguageLength = function(report) {
    return report.created_in_language && report.created_in_language !== 'en' && $scope.optionsLanguage ?  $scope.optionsLanguage.length : 0
  }

  $scope.containsValue = function(array, index) {
    var contains = false;
    angular.forEach(array, function(element) {
      if (element.toString() === index.toString()) {
        contains = true;
      }
    });
    return contains;
  };

  $scope.getReportFieldValue = function (report, field,rowNo,createdLanguage, new_data_fields_options) {
    var html = '';
    if (!report) {
      return html;
    }
    var index = null;
    var value = '';
    if (_.contains(['checkbox', 'checkboxJustifiedLeft'], field.component)) {
      if (report) {
        if (_.contains(Object.keys(report), 'value')) {
          if(!isNull(report.value)){
            if (angular.isArray(report.value)) {
              if (field.show_unselected_checkbox) {
                angular.forEach(new_data_fields_options.options, function (element, key) {
                  value = element.value ? element.value : element;
                  if ($scope.containsValue(report.value, key)) {
                    html += '<span class="selected">' + value + '<icon class="icon" icon-image="icon-check.svg" icon-width="15" icon-height="15" icon-color="secondaryColor"></icon></span>';
                  }
                  else {
                    html += '<span>' + value + '</span>';
                  }
                });
              }
              else {
                html += uniqueMethod(report, index, field, value, html,rowNo,createdLanguage,new_data_fields_options);
              }
            }
            else {
              if (field.show_unselected_checkbox) {
                angular.forEach(field.new_data_fields_options, function (element, key) {
                  value = element.value ? element.value : element;
                  if (report.value.toString() === key.toString()) {
                    html += '<span class="selected">' + value + '<icon class="icon" icon-image="icon-check.svg" icon-width="15" icon-height="15" icon-color="secondaryColor"></icon></span>';
                  }
                  else {
                    html += '<span>' + value + '</span>';
                  }
                });
              }
              else {
                index = isNaN(report.value) ? report.value : parseInt(report.value);

                var differentKeys =  findAnotherLang(report,createdLanguage);

                if(rowNo === '1'){
                  if (new_data_fields_options.options[index]) {
                    html = new_data_fields_options.options[index].value ? new_data_fields_options.options[index].value : new_data_fields_options.options[index];
                  }
                }else{
                  if(report.translatedValue){
                    html = report.translatedValue[differentKeys]
                  }
                }
              }
            }
          }
        }
        html += $scope.getExtraAttributes(report);
      }
    }
    else if (_.contains(['select', 'radio', 'radioJustifiedLeft', 'ratingScale3pt'], field.component)) {
      if (report) {
        if (_.contains(Object.keys(report), 'value')) {
          if(!isNull(report.value)){
            if (angular.isArray(report.value)) {
              html += uniqueMethod(report, index, field, value, html,rowNo,createdLanguage);
            }
            else {
              index = isNaN(report.value) ? report.value : parseInt(report.value);
              var differentKeys =  findAnotherLang(report,createdLanguage);

              if(rowNo === '1'){
                if (new_data_fields_options.options[index]) {
                  html = new_data_fields_options.options[index].value ? new_data_fields_options.options[index].value : new_data_fields_options.options[index];
                }
              }else{
                if(report.translatedValue){
                  html = report.translatedValue[differentKeys]
                }
              }
            }
          }
        }
        html += $scope.getExtraAttributes(report);
      }
    }
    else if (_.contains(['dateInput'], field.component)) {
      if (!isNull(report.value)) {
        if (_.contains(Object.keys(report), 'value')){
          if(!isNull(report.value)){
          html += '<span>' + moment(report.value).format('MM/DD/YYYY') + '</span>';
          }
        }
        html += $scope.getExtraAttributes(report);
      }
    }
    else if (_.contains(['dateTimeInput'], field.component)) {
      if (report) {
        if (_.contains(Object.keys(report), 'value')){
          if(!isNull(report.value)){
            html += '<span>' + moment(report.value).format('MM/DD/YYYY H:mm:ss') + '</span>';
          }
        }
        html += $scope.getExtraAttributes(report);
      }
    }
    else if (_.contains(['timeInput'], field.component)) {
      if (report) {
        var hour = new Date();
        if (_.contains(Object.keys(report), 'value')) {
          if (!isNull(report.value)) {
            hour.setHours(report.value.split(':')[0]);
            hour.setMinutes(report.value.split(':')[1]);
            html += '<span>' + moment(hour).format('H:mm') + '</span>';
          }
        }
        html += $scope.getExtraAttributes(report);
      }
    }
    else if (_.contains(['fileImageInput', 'fileInput', 'imageInput', 'imageMultipleInput', 'signatureInput'], field.component)) {
      if (report) {
        if (_.contains(Object.keys(report), 'value')) {
          if (!isNull(report.value)) {
            if (angular.isArray(report.value)) {
              angular.forEach(report.value, function (element) {
                var hrefurl;
                if (element.link) {
                  hrefurl = element.link;
                }
                else {
                  hrefurl = (element.thumbnail ? element.thumbnail : (element.document_file ? element.document_file.signed_view_url : (element.signed_view_url || element.file)));
                }
                if (!isNull(hrefurl)) {
                  if (AttachmentService.getClassesAttachment(element) === 'image') {
                    html += '<span><img src="' + hrefurl + '" name="' + element.name + '"/></span>';
                  }
                  else {
                    html += '<span><a href="' + hrefurl + '" target="_blank">' + element.name + '</a></span>';
                  }
                }
              });
            } else {
              var hreflink;
              if (report.value.link) {
                hreflink = report.value.link;
              }
              else {
                hreflink = (report.value.thumbnail ? report.value.thumbnail : (report.value.document_file ? report.value.document_file.signed_view_url : (report.value.signed_view_url || report.value.file)));
              }
              if (!isNull(hreflink)) {
                if (AttachmentService.getClassesAttachment(report.value) === 'image') {
                  html += '<span><img src="' + hreflink + '" name="' + (report.value && report.value.name) + '"/></span>';

                }
                else {
                  html += '<span><a href="' + hreflink + '" target="_blank">' + (report.value && report.value.name) + '</a></span>';
                }
              }
            }
          }
        }
        html += $scope.getExtraAttributes(report);
      }
    }
    else if (field.component === 'fileEmbedded') {
        if (field && !isNull(field.embedded) && (field.embedded.length > 0)) {
          var href;
          if (field.embedded[0] && field.embedded[0].link) {
            href = field.embedded[0].link;
          }
          else {
            href = (field.embedded[0] && field.embedded[0].thumbnail ? field.embedded[0].thumbnail : (field.embedded[0] && field.embedded[0].document_file ? field.embedded[0].document_file.signed_view_url : (field.embedded[0] && field.embedded[0].signed_view_url || field.embedded[0] && field.embedded[0].file)));
          }
          if (AttachmentService.getClassesAttachment(field.embedded[0]) === 'image') {
            // html += '<span><img src="' + href + '" name="' + field.embedded[0] && field.embedded[0].name + '"/></span>';
            html += '<span><img src="' + href + '" name="' + (field.embedded[0] ? field.embedded[0].name : '') + '"/></span>';
          }
          else {
            // html += '<span><a href="' + href + '" target="_blank">' + field.embedded[0] && field.embedded[0].name + '</a></span>';
            html += '<span><a href="' + href + '" target="_blank">' + (field.embedded[0] ? field.embedded[0].name : '') + '</a></span>';
          }
        }
    }
    else if (_.contains(['currencyInput'], field.component)) {
      if (report) {
        if (_.contains(Object.keys(report), 'value')) {
          if (!isNull(report.value)){
              html = $filter('currency')(report.value, '$', 2);
          }
        }
        html += $scope.getExtraAttributes(report);
      }
    }
    else {
      if (report) {
          if (_.contains(Object.keys(report), 'value')) {
            if (!isNull(report.value)){
              var differentKeys =  findAnotherLang(report,createdLanguage);

              if(rowNo === '1'){
                html = report.translatedValue && report.translatedValue['en'] || report.value
              }else{
                if(report.translatedValue){
                  html = report.translatedValue[differentKeys]
                }
              }
            
            }
          } 
          html += $scope.getExtraAttributes(report);
      }
    }

    return html;
  };

  $scope.multipleLanguage = function(report,field) {
    var multipleLanguage = report.new_data[field.id] && report.new_data[field.id].translatedValue ? true : false;
    return multipleLanguage;
  };

  function findAnotherLang(report,createdLanguage){
    if(report.translatedValue && Object.keys(report.translatedValue).length > 1){

      $scope.differentKeys = Object.keys(report.translatedValue)
      .filter(function(key) {
        return key === createdLanguage && report.translatedValue[key] === report.translatedValue[createdLanguage];
      });
    }

    return $scope.differentKeys;

  }

  function uniqueMethod(report, index, field, value, html,rowNo,createdLanguage, new_data_fields_options){

    var differentKeys =  findAnotherLang(report,createdLanguage);

    if(rowNo === '1'){
      angular.forEach(report.value, function (element) {
        index = isNaN(element) ? element : parseInt(element);
        if (new_data_fields_options.options[index]) {
          value = new_data_fields_options.options[index].value ? new_data_fields_options.options[index].value : new_data_fields_options.options[index];
          html += '<span>' + value + '</span>';
        }
      });
    }else{
      if(report.translatedValue){
        html += '<span>' + report.translatedValue[differentKeys] + '</span>';
      }
    }
    
    return html;
  }

  $scope.getValueField = function (report, field,rowNo) {
    if(FilterService.hasFilter('include_tags')) {
      switch (field.id) {
        case 'portfolio_id':
          return report.portfolio?.id;
        case 'property_id':
          return report.property?.id;
        case 'action_item_id':
          return report.action_item?.id;
        case 'workflow_instance_id':
          return report.workflow_instance?.id;
        case 'portfolio_name':
          return report.portfolio?.name;
        case 'property_name':
          return report.property?.name;
        case 'pms_property_id':
            return report.property?.pms_property_id;
        case 'property_address':
            return report.property?.property_address;
        case 'datetime_of_inspection':
            return report.property?.datetime_of_inspection ? moment(report.property?.datetime_of_inspection).format('MM/DD/YYYY') : null;
        case 'inspected_by':
            return report.property?.inspected_by;
        case 'unit_building':
            return report.property?.unit_building;
        case 'unit_number':
            return report.property?.unit_number;
        case 'unit_type':
            return report.property?.unit_type;
        case 'pdf_file':
            var pdfUrl1 = report.pdf_file_signed || report.pdf_file;
            return '<span><a href="' + pdfUrl1 + '" target="_blank">' + pdfUrl1 + '</a></span>';
        default:
          var createdLanguage = report.created_in_language ? report.created_in_language : 'en'
          return $scope.getReportFieldValue(report.new_data[field.id], field,rowNo,createdLanguage, report.new_data_dynamic_fieldsOptions[field.id]);
      }
    }
    else {
      switch (field.id) {
        case 'portfolio_id':
          return report.portfolio?.id;
        case 'property_id':
          return report.property?.id;
        case 'action_item_id':
          return report.action_item?.id;
        case 'workflow_instance_id':
          return report.workflow_instance?.id;
        case 'portfolio_name':
          return report.portfolio?.name;
        case 'property_name':
          return report.property?.name;
        case 'pms_property_id':
            return report.property?.pms_external_id;
        case 'property_address':
            return report.property?.fields?.property_complete_address;
        case 'datetime_of_inspection':
            return report.action_item?.completed_date ? moment(report.action_item?.completed_date).format('MM/DD/YYYY') : null;
        case 'inspected_by':
            return report.data?.username?.value;
        case 'unit_building':
            return report.data?.unitbuilding?.value;
        case 'unit_number':
            return report.data?.unitnumber?.value;
        case 'unit_type':
            return report.data['unitInfo#0']?.value;
        case 'pdf_file':
            var pdfUrl2 = report.pdf_file_signed || report.pdf_file;
            if (pdfUrl2){
              return '<span class="link" color="secondaryColor"><a href="' + pdfUrl2 + '" target="_blank">' + pdfUrl2 + '</a></span>';
            }
            else {
              return ''
            }
        default:
          var createdLanguage = report.created_in_language ? report.created_in_language : 'en'
          return $scope.getReportFieldValue(report.new_data[field.id], field,rowNo,createdLanguage, report.new_data_dynamic_fieldsOptions[field.id]);
      }
    }
  };

  $scope.getFieldClasses = function (field) {
    var classes = [];
    if (_.contains(['fileImageInput', 'fileInput', 'imageInput', 'imageMultipleInput', 'signatureInput', 'fileEmbedded'], field.component)) {
      classes.push('field-media');
    }
    return classes;
  };

  $scope.getIndexDynamic = function (id, dynamic_form_id) {
    var index = -1;
    angular.forEach($scope.reportsGrouped[$scope.getIndex(id)].dynamic_forms, function (value, key) {
      if (value.id === dynamic_form_id) {
        index = key;
      }
    });
    return index;
  };

  $scope.getIndexSection = function (id, dynamic_form_id, section_id) {
    var index = -1;
    angular.forEach($scope.reportsGrouped[$scope.getIndex(id)].dynamic_forms[$scope.getIndexDynamic(id, dynamic_form_id)].sectionLabels, function (value, key) {
      if (value.id === section_id) {
        index = key;
      }
    });
    return index;
  };

  $scope.getIndexField = function (id, dynamic_form_id, field_id) {
    var index = -1;
    angular.forEach($scope.reportsGrouped[$scope.getIndex(id)].dynamic_forms[$scope.getIndexDynamic(id, dynamic_form_id)].fields, function (value, key) {
      if (value.id === field_id) {
        index = key;
      }
    });
    return index;
  };

  $scope.getIndexSectionById = function(dynamic_form_id, id, originId) {
    var index = null;
    var sections = $scope.reportsGrouped[$scope.getIndex(id)].dynamic_forms[$scope.getIndexDynamic(id,
      dynamic_form_id)].sectionLabels;
    angular.forEach(sections, function (section) {
      var label = section.label ? section.label.toLowerCase().replace(/^\s+|\s{1,50}$/g, '_').replace(/[^\w-]+/g, '') : '';
      if (section.id === (label + '@' + originId)) {
        index = section.index;
      }
    });
    return index;
  };

  $scope.getIndexFieldById = function(dynamic_form_id, id, originId) {
    var index = null;
    var fields = $scope.reportsGrouped[$scope.getIndex(id)].dynamic_forms[$scope.getIndexDynamic(id,
      dynamic_form_id)].fields;
    angular.forEach(fields, function (field) {
      if ((field.original_id === originId)) {
        index = field.original_index;
      }
    });
    return index;
  };

  $scope.reindexCopySections = function(group_id, dynamic_form_id, originId, new_index) {
    var sections = $scope.reportsGrouped[$scope.getIndex(group_id)].dynamic_forms[$scope.getIndexDynamic(group_id,
      dynamic_form_id)].sectionLabels;
    angular.forEach(sections, function (section) {
      var sectionOriginId = section.originId || section.id;
      if ((sectionOriginId === originId) && (new_index > section.index)) {
        section.index = new_index;
      }
    });
    $scope.reportsGrouped[$scope.getIndex(group_id)].dynamic_forms[$scope.getIndexDynamic(group_id,
      dynamic_form_id)].sectionLabels = sections;
  };

  $scope.reindexCopyFields = function(group_id, dynamic_form_id, originId, sectionId, new_index) {
    var fields = $scope.reportsGrouped[$scope.getIndex(group_id)].dynamic_forms[$scope.getIndexDynamic(group_id,
      dynamic_form_id)].fields;
    angular.forEach(fields, function (field) {
      if ((field.originId === originId) && (field.section_id === sectionId) && (new_index > field.index)) {
        field.index = new_index;
      }
    });
    $scope.reportsGrouped[$scope.getIndex(group_id)].dynamic_forms[$scope.getIndexDynamic(group_id,
      dynamic_form_id)].fields = fields;
  };

  $scope.generateStructureSection = function(dynamic_form_id, group_id , field) {
    var exp = getExpDecimal(field.children.length);
    $scope.exp =  (exp > $scope.exp) ? exp : $scope.exp;
    var label = field.label ? field.label.toLowerCase().replace(/^\s+|\s{1,50}$/g, '_').replace(/[^\w-]+/g, '') : '';
    var originId = field.originId || field.origin_id;
    var sectionOriginId = originId || field.id;
    var sectionId = label + '@' + sectionOriginId;
    var dynamicForm = $scope.reportsGrouped[$scope.getIndex(group_id)].dynamic_forms[$scope.getIndexDynamic(group_id,
      dynamic_form_id)];
    if (dynamicForm && dynamicForm.sectionLabels.map(function (e) {
      return e.id;
    }).indexOf(sectionId) < 0) {
      var index = originId ? $scope.getIndexSectionById(dynamic_form_id, group_id, originId) : field.index;
      $scope.reportsGrouped[$scope.getIndex(group_id)].dynamic_forms[$scope.getIndexDynamic(group_id,
        dynamic_form_id)].sectionLabels.push({
        label: field.label,
        children: 0,
        id: sectionId,
        originId: originId,
        index: index
      });
    }
    else {
      var new_index = originId ? $scope.getIndexSectionById(dynamic_form_id, group_id, originId) : field.index;
      var index1 = dynamicForm ? dynamicForm.sectionLabels[$scope.getIndexSection(group_id, dynamic_form_id, sectionId)].index : new_index;
      if (new_index > index1) {
        dynamicForm.sectionLabels[$scope.getIndexSection(group_id, dynamic_form_id, sectionId)].index = new_index;
        $scope.reindexCopySections(group_id, dynamic_form_id, sectionOriginId, new_index);
      }
    }
  };

  $scope.generateStructureField = function(dynamic_form_id, group_id, field, child,dynamic_form) {
    if (FilterService.hasFilter('fields_active')) {
      var fields = FilterService.getFilter('fields_active').split(',');
    }
    var label = field.label ? field.label.toLowerCase().replace(/^\s+|\s{1,50}$/g, '_').replace(/[^\w-]+/g, '') : '';
    var fieldOriginId = field.originId || field.origin_id;
    var sectionOriginId = fieldOriginId || field.id;
    var sectionId = label + '@' + sectionOriginId;
    var originId = child.originId || child.origin_id;
    var groupId = child.groupId || child.group_id;
    var childId = groupId || child.id;
    if (sectionId === childId) return;
    childId = childId.toLowerCase();
    var indexSection = $scope.reportsGrouped[$scope.getIndex(group_id)].dynamic_forms[$scope.getIndexDynamic(group_id,
      dynamic_form_id)]?.sectionLabels[$scope.getIndexSection(group_id, dynamic_form_id, sectionId)].index;
    if (isNull(fields) || _.contains(fields, childId)) {
      if ($scope.reportsGrouped[$scope.getIndex(group_id)].dynamic_forms[$scope.getIndexDynamic(group_id,
        dynamic_form_id)]?.fields.map(function(e) {
        return e.id;
      }).indexOf(childId) < 0 && !_.contains($scope.fieldInvalidTypes, child.component)) {
        $scope.reportsGrouped[$scope.getIndex(group_id)].dynamic_forms[$scope.getIndexDynamic(group_id,
          dynamic_form_id)].sectionLabels[$scope.getIndexSection(group_id, dynamic_form_id,
          sectionId)].children++;
        var index = (originId !== child.id) ? $scope.getIndexFieldById(dynamic_form_id, group_id, originId) : child.index;
        var obj = {
          label: child.label,
          id: childId,
          original_id: child.id,
          component: child.component,
          section: {
            id: field.id,
            label: field.label
          },
          section_id: sectionId,
          index: ((10 ** $scope.exp) * indexSection) + index,
          original_index: index
        };
        if (child.options) {
          obj.options = child.options;
        }
        if (originId !== child.id) {
          obj.originId = originId;
        }
        if (child.embedded) {
          obj.embedded = child.embedded;
        }
        $scope.reportsGrouped[$scope.getIndex(group_id)].dynamic_forms[$scope.getIndexDynamic(group_id,
          dynamic_form_id)].fields.push(obj);
      }
      else if (!_.contains($scope.fieldInvalidTypes, child.component)) {
        var index1 = $scope.reportsGrouped[$scope.getIndex(group_id)].dynamic_forms[$scope.getIndexDynamic(group_id,
          dynamic_form_id)]?.fields[$scope.getIndexField(group_id, dynamic_form_id, childId)].index;
        var new_child_index = (originId !== child.id) ?
          $scope.getIndexFieldById(dynamic_form_id, group_id, originId) : child.index;
        var new_index = ((10 ** $scope.exp) * indexSection) + new_child_index;
        if (new_index > index1) {
          $scope.reportsGrouped[$scope.getIndex(group_id)].dynamic_forms[$scope.getIndexDynamic(group_id,
            dynamic_form_id)].fields[$scope.getIndexField(group_id, dynamic_form_id, childId)].index = new_index;
          $scope.reindexCopyFields(group_id, dynamic_form_id, originId, sectionId, new_index);
        }
      }
    }
  };
  

  $scope.generateBasicStructureGroup = function(group, value) {
    if ($scope.getIndex(group.id) < 0) {
      $scope.reportsGrouped.push({id: group.id, name: group.name, dynamic_forms: []});
    }
    if ($scope.dynamic_form) {
      if ($scope.getIndexDynamic(group.id, $scope.dynamic_form.id) < 0) {
        $scope.reportsGrouped[$scope.getIndex(group.id)].dynamic_forms.push({
          id: $scope.dynamic_form.id,
          reports: [],
          fields: [],
          sectionLabels: [],
          name: $scope.dynamic_form.name
        });
        angular.forEach($scope.dynamic_form.fields, function(field) {
          $scope.generateStructureSection($scope.dynamic_form.id, group.id, field);
        });
      }
    }
    else {
      if ($scope.getIndexDynamic(group.id, value.dynamic_form.id) < 0) {
        $scope.reportsGrouped[$scope.getIndex(group.id)].dynamic_forms.push({
          id: value.dynamic_form.id,
          reports: [],
          fields: [],
          sectionLabels: [],
          name: value.dynamic_form.name
        });
      }
    }
    angular.forEach(value.dynamic_form_fields, function(field) {
      $scope.generateStructureSection(value.dynamic_form.id, group.id, field);
    });
    if ($scope.dynamic_form) {
      if(FilterService.hasFilter('include_tags')) {
        angular.forEach(value.dynamic_form_fields, function(field) {
          $scope.generateStructureSection(value.dynamic_form.id, group.id, field);
        });
      }
      else {
        angular.forEach(value.dynamic_form_fields, function(field) {
          angular.forEach(field.children, function(child) {
            $scope.generateStructureField($scope.dynamic_form.id, group.id, field, child,$scope.dynamic_form);
          });
        });
      }
    }
  };

  $scope.createNewDynamicFormFieldsData =function(value){
    var new_data_fields = {};
    if (FilterService.hasFilter('extra_fields')) {
      $scope.extra_fields = FilterService.getFilter('extra_fields').split(',');
    }
    else {
      $scope.extra_fields = [];
    }
    if (FilterService.hasFilter('fields_active')) {
      var fields = FilterService.getFilter('fields_active').split(',');
    }
    angular.forEach(value.dynamic_form_fields, function(field) {
      angular.forEach(field.children, function(child) {
        var groupId = child.groupId || child.group_id;
        var childId = groupId || child.id;
        childId = childId.toLowerCase();
        if (isNull(fields) || _.contains(fields, childId)) {
          if(value.dynamic_form_fields){
            new_data_fields[childId] = value.dynamic_form_fields.find(x => x.id === child.section)?.children.find(y => y.groupId === child.groupId);
          }
        }
      })
    })
    return new_data_fields;
  }

  $scope.createNewData = function (value, group_id) {
    var new_data = {};
    if (FilterService.hasFilter('extra_fields')) {
      $scope.extra_fields = FilterService.getFilter('extra_fields').split(',');
    }
    else {
      $scope.extra_fields = [];
    }
    if (FilterService.hasFilter('fields_active')) {
      var fields = FilterService.getFilter('fields_active').split(',');
    }
    angular.forEach(value.dynamic_form_fields, function(field) {
      angular.forEach(field.children, function(child) {
        $scope.generateStructureField(value.dynamic_form.id, group_id, field, child,value.dynamic_form);
        var groupId = child.groupId || child.group_id;
        var childId = groupId || child.id;
        childId = childId.toLowerCase();
        if (isNull(fields) || _.contains(fields, childId)) {
          var customArray ={};
          
          if(value.dynamic_form && $scope.optionsLanguage && $scope.optionsLanguage.length > 1 && 
             value.dynamic_form.locale && Object.keys(value.dynamic_form.locale).length > 0 && child.options && child.options.length > 0 && value.data[child.id]){
            var translatedValue = {};
            var key = Object.keys(value.data[child.id])[0]
            if(value.data[child.id][key] && value.data[child.id][key].length > 1){
              var key_locale = ""
                angular.forEach($scope.optionsLanguage, function(lang){
                  var translatedValueMultiple = ""

                  angular.forEach(value.data[child.id][key], function(valueData){
                    key_locale  = child.id+'_'+key+'-'+valueData;
                    var filter_locale = value.dynamic_form.locale[lang.code];
                    if (translatedValueMultiple !== "") {
                      translatedValueMultiple += '<br>';
                  }
                  if(filter_locale){
                    translatedValueMultiple += filter_locale[key_locale];
                    translatedValue[lang.code] = translatedValueMultiple;
                  }
                  });
                })
                customArray = {
                  translatedValue: translatedValue,
                  value: value.data[child.id][key]
                };
            }else{
              var key_locale = child.id+'_'+key+'-'+value.data[child.id][key];
              angular.forEach($scope.optionsLanguage, function(lang){
                var filter_locale = value.dynamic_form.locale[lang.code];
                if(filter_locale){
                  translatedValue[lang.code] = filter_locale[key_locale];
                }
              })
              customArray = {
                translatedValue: translatedValue,
                value: value.data[child.id][key]
              };
            }
            
          }
          if(value.dynamic_form && $scope.optionsLanguage && $scope.optionsLanguage.length > 1 && value.dynamic_form.locale && Object.keys(value.dynamic_form.locale).length > 0 && value.data[child.id]){
            if(child.options && child.options.length > 0 ){
              new_data[childId] = value.data[child.id].translatedValue ? value.data[child.id] : customArray;
            }
            else{
              new_data[childId] = value.data[child.id];
            }
          }else{
            new_data[childId] = value.data[child.id];
          }
        }
      });
    });
    return new_data;
  };

  $scope.reIndexSections = function() {
    angular.forEach($scope.reportsGrouped, function(group){
      angular.forEach(group.dynamic_forms, function (dynamic_form) {
        var index_array = [];
        angular.forEach(dynamic_form.sectionLabels, function (section) {
          var counts = _.countBy(index_array)[section.index];
          index_array.push(section.index);
          if (counts > 0) {
            section.index = section.index + counts;
          }
        });
        dynamic_form.sectionLabels = $filter('orderBy')(dynamic_form.sectionLabels, ['index','id','label']);
        var index = 0;
        angular.forEach(dynamic_form.sectionLabels, function (section) {
          section.index = index++;
        });
      });
    });
  };

  $scope.reIndexFields = function() {
    angular.forEach($scope.reportsGrouped, function(group){
      angular.forEach(group.dynamic_forms, function (dynamic_form) {
        var index_array = [];
        angular.forEach(dynamic_form.fields, function (field) {
          var counts = _.countBy(index_array)[field.index];
          index_array.push(field.index);
          if (counts > 0) {
            field.index = field.index + counts;
          }
        });
        dynamic_form.fields = $filter('orderBy')(dynamic_form.fields, ['index','id','label']);
        var index = 0;
        angular.forEach(dynamic_form.fields, function (field) {
          field.index = index++;
        });
      });
    });
  };

  $scope.addReportToGroup = function(group_id, value) {
    if (getIndexArray($scope.reportsGrouped[$scope.getIndex(group_id)].dynamic_forms[$scope.getIndexDynamic(group_id, value.dynamic_form.id)]?.reports, value.id) < 0) {
      value.new_data = $scope.createNewData(value, group_id);
      value.new_data_dynamic_fieldsOptions = $scope.createNewDynamicFormFieldsData(value, group_id);
      $scope.reportsGrouped[$scope.getIndex(group_id)]?.dynamic_forms[$scope.getIndexDynamic(group_id, value.dynamic_form.id)]?.reports.push(value);
    }
  };

  $scope.groupReports = function(data) {
    $scope.exp = 1;
    if (data.results) {
      $scope.reports = data.results ? data.results : data;
      if (data.results.info_data) {
        $scope.info_data = data.results.info_data;
      }
    } else {
      $scope.reports = data;
    }

    $scope.reportsGrouped = [];
    var id = 'ungroup';
    var name = 'Ungroup';
    var array_by_name = [];
    switch (FilterService.getFilter('group_by')) {
      case 'account':
        angular.forEach($scope.accounts_by_name, function (account) {
          if (getIndexArray(array_by_name, account.id) < 0) {
            array_by_name.push({id: account.id, name: account.name});
          }
        });
        break;
      case 'portfolio':
        angular.forEach($scope.portfolios_by_name, function (portfolio) {
          if (getIndexArray(array_by_name, portfolio.id) < 0) {
            array_by_name.push({id: portfolio.id, name: portfolio.name});
          }
        });
        break;
      case 'property':
        angular.forEach($scope.properties_by_name, function (property) {
          if (getIndexArray(array_by_name, property.id) < 0) {
            array_by_name.push({id: property.id, name: property.name});
          }
        });
        break;
    }
    angular.forEach($scope.reports, function(value) {
      switch (FilterService.getFilter('group_by')) {
        case 'account':
          if (value.account) {
            id = value.account.id;
            name = value.account.name;
          }
          else {
            id = 'no_account';
            name = 'No account';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'portfolio':
          if (value.portfolio) {
            id = value.portfolio.id;
            name = value.portfolio.name;
          }
          else {
            id = 'no_portfolio';
            name = 'No portfolio';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'property':
          if (value.property) {
            id = value.property.id;
            name = value.property.name;
          }
          else {
            id = 'no_property';
            name = 'No property';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'group':
          if (value.groups && value.groups.length > 0) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.groups, function (group) {
              updateDynamicFormGroupCase(group, id, name, array_by_name);
            });
          }
          else if (value.property && value.property.groups && (value.property.groups.length > 0)) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.property.groups, function (group) {
              updateDynamicFormGroupCase(group, id, name, array_by_name);
            });
          }
          else if (value.portfolio && value.portfolio.groups && (value.portfolio.groups.length > 0)) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.portfolio.groups, function (group) {
              updateDynamicFormGroupCase(group, id, name, array_by_name);
            });
          }
          else {
            id = 'no_group';
            name = 'No group';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'managed_by':
          if (value.managed_by) {
            if (angular.isArray(value.managed_by)){
              id = [];
              name = [];
              array_by_name = [];
              angular.forEach(value.managed_by, function (manager) {
                updateDynamicFormManagedbyCase(manager, id, name, array_by_name);
              });
            }
            else {
              id = value.managed_by.id;
              name = value.managed_by.name;
              array_by_name.push({id: value.managed_by.id, name: value.managed_by.name});
            }
          }
          else {
            id = 'only_owner';
            name = 'Only Owner';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'user_role':
          if (value.account_user) {
            id = value.account_user.role;
            name = value.account_user.role;
            array_by_name = [{id: id, name: name}];
          }
          break;
      }
      if (angular.isArray(id)){
        angular.forEach(array_by_name, function (value_manager) {
          $scope.generateBasicStructureGroup(value_manager, value);
        });
      }
      else {
        $scope.generateBasicStructureGroup({id: id, name: name }, value);
      }
    });
    $scope.reIndexSections();
    angular.forEach($scope.reports, function(value) {
      switch (FilterService.getFilter('group_by')) {
        case 'account':
          if (value.account) {
            id = value.account.id;
            name = value.account.name;
          }
          else {
            id = 'no_account';
            name = 'No account';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'portfolio':
          if (value.portfolio) {
            id = value.portfolio.id;
            name = value.portfolio.name;
          }
          else {
            id = 'no_portfolio';
            name = 'No portfolio';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'property':
          if (value.property) {
            id = value.property.id;
            name = value.property.name;
          }
          else {
            id = 'no_property';
            name = 'No property';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'group':
          if (value.groups && value.groups.length > 0) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.groups, function (group) {
              updateDynamicFormGroupCase(group, id, name, array_by_name);
            });
          }
          else if (value.property && value.property.groups && (value.property.groups.length > 0)) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.property.groups, function (group) {
              updateDynamicFormGroupCase(group, id, name, array_by_name);
            });
          }
          else if (value.portfolio && value.portfolio.groups && (value.portfolio.groups.length > 0)) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.portfolio.groups, function (group) {
              updateDynamicFormGroupCase(group, id, name, array_by_name);
            });
          }
          else {
            id = 'no_group';
            name = 'No group';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'managed_by':
          if (value.managed_by) {
            if (angular.isArray(value.managed_by)){
              id = [];
              name = [];
              array_by_name = [];
              angular.forEach(value.managed_by, function (manager) {
                updateDynamicFormManagedbyCase(manager, id, name, array_by_name);
              });
            }
            else {
              id = value.managed_by.id;
              name = value.managed_by.name;
              array_by_name.push({id: value.managed_by.id, name: value.managed_by.name});
            }
          }
          else {
            id = 'only_owner';
            name = 'Only Owner';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'user_role':
          if (value.account_user) {
            id = value.account_user.role;
            name = value.account_user.role;
            array_by_name = [{id: id, name: name}];
          }
          break;
      }
      if (angular.isArray(id)){
        angular.forEach(array_by_name, function (value_manager) {
          $scope.addReportToGroup(value_manager.id, value);
        });
      }
      else {
        $scope.addReportToGroup(id, value);
      }
    });
    $scope.reIndexFields();
    if ($scope.reportsGrouped.length === 1) {
      $scope.groupExpanded = $scope.reportsGrouped[0].id;
    }
    else {
      $scope.reportsGrouped = $filter('orderBy')($scope.reportsGrouped, 'name');
    }
  };

  function updateDynamicFormGroupCase(group, id, name, array_by_name) {
    if (FilterService.hasFilter('group_reports')) {
      if (_.contains(FilterService.getFilter('group_reports').toString().split(','), group.id.toString())) {
        id.push(group.id);
        name.push(group.name);
        array_by_name.push({ id: group.id, name: group.name });
      }
    } else {
      id.push(group.id);
      name.push(group.name);
      array_by_name.push({ id: group.id, name: group.name });
    }
  }

  function updateDynamicFormManagedbyCase(manager, id, name, array_by_name) {
    id.push(manager.id);
    name.push(manager.name);
    array_by_name.push({ id: manager.id, name: manager.name });
  }

  $scope.$on('filter-dynamic-form:updated', function(event, dynamic_form) {
    $scope.dynamic_form = dynamic_form;
    if (!dynamic_form) {
      $scope.initDynamic = false;
    }
  });

};

app.controller('ReportsDynamicFormList', ['$scope', '$rootScope', '$controller', '$filter', 'FilterService',
  'ReportService','AuthService', 'ReportFilterService', 'AttachmentService','AuthDataService', ReportsDynamicFormList
]);
